export default __webpack_public_path__ + "static/media/hero-main.24bc8355.png";